import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getSocialMedia = () =>
  axiosInstance.get(`${LANDING_API_URL}/setting/social-media-links`, {
    headers: authHeaders(),
  });

export const updateSocialMediaRequest = (socialMediaData) =>
  axiosInstance.put(
    `${LANDING_API_URL}/setting/social-media-links`,
    socialMediaData,
    {
      headers: authHeaders(),
    },
  );
